import React from 'react';

export default () => (
  <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.49312 4.925L8.68907 2.72905C8.90364 2.51448 8.90364 2.16751 8.68907 1.95293L7.39707 0.66093C7.18249 0.446357 6.83552 0.446357 6.62095 0.66093L4.425 2.85688L2.22905 0.66093C2.01448 0.446357 1.66751 0.446357 1.45293 0.66093L0.16093 1.95293C-0.0536433 2.16751 -0.0536433 2.51448 0.16093 2.72905L2.35688 4.925L0.16093 7.12095C-0.0536433 7.33552 -0.0536433 7.68249 0.16093 7.89707L1.45293 9.18907C1.66751 9.40364 2.01448 9.40364 2.22905 9.18907L4.425 6.99312L6.62095 9.18907C6.83552 9.40364 7.18249 9.40364 7.39707 9.18907L8.68907 7.89707C8.90364 7.68249 8.90364 7.33552 8.68907 7.12095L6.49312 4.925Z"
      fill="#A5A5A5"
    />
  </svg>
);
